import { createApi } from '@reduxjs/toolkit/query/react';
import { ENDPOINT_CONSTANTS } from '../../constant';
import baseQueryWithReauth from 'service/baseQuery/baseQuery';
import { ProgressType } from 'pages/candidateDashboard/candidateDashboard.type';

type ResponseItem = {
  _id: string;
  value: string;
  category: string;
  desc: string;
  __v: number;
};

type ApiResponse<T> = {
  data: T;
  status: number;
  message?: string;
};

export const candidateQuery = createApi({
  reducerPath: 'candidateQuery',
  baseQuery: baseQueryWithReauth,
  endpoints: builder => ({
    findCandidateRoles: builder.query({
      query: () => ({
        url: ENDPOINT_CONSTANTS.ROLE,
        method: 'GET'
      }),
      transformResponse: <T extends ResponseItem[]>(
        response: ApiResponse<T> | undefined
      ): { value: string; label: string }[] | undefined => {
        return response?.data?.map(({ value: label, _id: value }) => ({
          value,
          label
        }));
      }
    }),
    getProgress: builder.query<ProgressType, void>({
      query: () => ({
        url: ENDPOINT_CONSTANTS.CANDIDATE_PROGRESS,
        method: 'GET'
      }),
      transformResponse: (
        response: ApiResponse<ProgressType> | undefined
      ): ProgressType => {
        return (
          response?.data ?? {
            signUp: true,
            basicInfoForm: true,
            coreBasicsCompleted: false,
            crackedLogic: false,
            personalityRoundCompleted: false,
            profileCompleted: false,
            shortlistedForJob: false,
            matchFound: false,
            getHired: false
          }
        );
      }
    })
  })
});

export const { useFindCandidateRolesQuery, useLazyGetProgressQuery } =
  candidateQuery;
